//import ColumnHeaderData from "../components/data-table/columnHeaderData";

const titulosTablasTempMensual = [
    "Hora UTC",
    "-10 a -5",
    " -5 a 0",
    "0 a 5",
    "5 a 10",
    "10 a 15",
    "15 a 20",
    "20 a 25",
    "25 a 30",
    "30 a 35",
    "35 a 40",
    "mayor a 40",
];

const visibilidadTitulosCols = [
    "HORA",
    "0 a 200",
    "201 a 400",
    "401 a 600",
    "601 a 800",
    "801 a 1500",
    "1501 a 3000",
    "3001 a 5000",
    "5001 a 8000",
];

const altNubesTitulosCols = [
    "HORA (UTC) / Alt.Nubes(m)",
    "0 a 30",
    "31 a 60",
    "61 a 90",
    "91 a 150",
    "151 a 300",
    "301 a 450",
];

const tablasRvrTitulosCols1 = [
    "RVR (m)",
    "[0-50]",
    "[51-200]",
    "[201-350]",
    "[351-550]",
    "[551-1500]",
];

const tablasRvrTitulosCols2 = [
    "HORA (UTC) / Alt.Nubes(m)",
    "",
    "",
    "[0-100]",
    "[101-200]",
    "[201-300]",
];

const fenomenosTitulosCols = [
    "HORA(UTC)",
    "LLUVIAS",
    "LLOVIZNAS",
    "CON LLUVIAS",
    "CON GRANIZO",
    "SIN LLUVIAS",
    "NIEBLA",
    "NEBLINA",
    "HUMO",
];

const visibAltNubesTitulosCols1 = [
    "VISIBILIDAD (metros)",
    "[0-800]",
    "[801-1500]",
    "[1501-3000]",
    "[3001-8000]",
];
const visibAltNubesTitulosCols2 = [
    "HORA (UTC)  /  ALT. NUBE (metros)",
    "[0-200]",
    "[201-500]",
    "[501-1000]",
    "[1001-2000]",
];

const intVientoFrecAbsTitulosCols = [
    "Dir./Int.(kt)",
    "1 a 5",
    "6 a 10",
    "11 a 15",
    "16 a 20",
    "21 a 25",
    "26 a 30",
    "31 a 35",
    "36 a 40",
    "41 a 45",
    "46 a 50",
    "> 50",
    "TOTAL",
];

const TABLA = 0
const RESUMEN = 1

const DatosTablas = {
    prefijoNomarchivosTablas: [
        "temperatura",
        "precipitacion",
        "qnh_media",
        "Temp_aire_frec_porc",
        "Visibilidad_frec_porc",
        "Altura_nubes_frec_porc",
        "RVR19_altura_nubes_frec_porc",
        "RVR24_altura_nubes_frec_porc",
        "Fenomenos_frec_abs",
        "Visib_altura_nubes_frec_porc",
        "Viento",
    ],

    titulosTablas: [
        "Temperatura",
        "Precipitación",
        "QNH MEDIA",
        "Temp. Aire - Frecuencia en porcentaje sobre el total por hora",
        "Visibilidad",
        "Altura de Nubes - Frec. en porcentaje sobre el total por hora",
        "RVR 19",
        "RVR 24",
        "Fenómenos Significativos",
        "Visibilidad/Altura de Nubes",
        "Viento por mes/hora",
    ],

    tipoTablas: [
        TABLA,
        TABLA,
        TABLA,
        RESUMEN,
        RESUMEN,
        RESUMEN,
        RESUMEN,
        RESUMEN,
        TABLA,
        TABLA,
        RESUMEN,
    ],

    tablasDisponiblesPorEstacion: {
        39: [true, true, true, true, true, true, true, true, true, true, true],
        138: [true, true, true, true, true, true, false, false, true, true, true],
        96: [true, true, true, true, true, true, false, false, true, true, true],
        239: [true, true, true, true, true, true, false, false, true, true, true]
    },

    tablaPorDefecto: {
        39: [0,3],
        138:[0,3],
        96:[0,3],
        239:[0,3]
    },


    descripcionTablas: [
        "Temperatura media mensual en °C",
        "Precipitación mensual en mm",
        "Presión atmosférica a nivel del Aeródromo mensual y horario, en hPa",
        "Frecuencia en porcentaje sobre el total por hora de la temperatura del aire a intervalos determinados de 5ºC",
        "Visibilidad horizontal - Frecuencia en porcentaje sobre el total por hora",
        "Frecuencia en porcentaje sobre el total por hora de la altura en metros de la base de la capa más baja de las nubes en caso de presentarse BKN u OVC",
        "Alcance visual en cabecera de Pista 19 combinado con la altura de la base de la capa más baja de nubes en caso de BKN u OVC. Frecuencia en porcentaje sobre el total por hora",
        "Alcance visual en cabecera de Pista 24 combinado con la altura de la base de la capa más baja de nubes en caso de BKN u OVC. Frecuencia en porcentaje sobre el total por hora",
        "Frecuencia de ocurrencias en cantidades absolutas",
        "Frecuencia de ocurrencias en porcentajes sobre total por hora",
        "Frecuencia de ocurrencias en kt",
    ],




    cantObs: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],

    tablasPorMesHora: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        true,
    ],
    tablasPorMes: [
        false,
        false,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
    ],





    titulosColsTablas: [
        [
            "MES",
            "MEDIA",
            "MÁX MEDIA",
            "MÍN MEDIA",
            "MÁX ABS",
            "MÍN ABS"
        ],
        ["MES", "ACUMULADO MEDIO", "MÁXIMO 24HS", "NRO. MEDIO DE DÍAS LLUVIA"],
        [
            "HORA",
            "ENE",
            "FEB",
            "MAR",
            "ABR",
            "MAY",
            "JUN",
            "JUL",
            "AGO",
            "SET",
            "OCT",
            "NOV",
            "DIC",
        ],
        titulosTablasTempMensual,
        visibilidadTitulosCols,
        altNubesTitulosCols,
        tablasRvrTitulosCols1,
        tablasRvrTitulosCols1,
        fenomenosTitulosCols,
        visibAltNubesTitulosCols1,
        intVientoFrecAbsTitulosCols,
    ],

    titulosCols2Tablas: [
        [],
        [],
        [],
        [],
        [],
        [],
        tablasRvrTitulosCols2,
        tablasRvrTitulosCols2,
        [],
        visibAltNubesTitulosCols2,
        [],
    ],
};

export { DatosTablas };
